const navigationActionsTypes = {
    SET_SUPPLIER_NAV: 'SET_SUPPLIER_NAV',
    SET_BURGER_MENU: 'SET_BURGER_MENU',
    SET_WINDOW_WIDTH: 'SET_WINDOW_WIDTH',
    RESET_NAV: 'RESET_NAV'
}

export default navigationActionsTypes;